export const SPONSOR_REACH = "SPONSOR_REACH";
export const SPONSOR_VALUE = "SPONSOR_VALUE";
export const TV_ENGAGEMENT = "TV_ENGAGEMENT";
export const BRAND_SOURCES = "BRAND_SOURCES";
export const PARTNER_DIVIDED_REACH = "PARTNER_DIVIDED_REACH";
export const PARTNER_VALUE = "PARTNER_VALUE";
export const PARTNER_DIVIDED_VALUE = "PARTNER_DIVIDED_VALUE";
export const PARTNER_REACH = "PARTNER_REACH";
export const SPONSOR_DIVIDED_REACH = "SPONSORDIVIDEDREACH";
export const SPONSOR_DIVIDED_VALUE = "SPONSORDIVIDEDVALUE";
export const SPONSOR_PERFORMANCE_BUBBLE = "SPONSOR_PERFORMANCE_BUBBLE";
export const SPONSOR_STATION_DIVIDED_VALUE = "SPONSORSTATIONDIVIDEDVALUE";
export const SPONSOR_VALUE_PER_SOURCE = "SPONSOR_VALUE_PER_SOURCE";
export const SPONSOR_LOGO_STATS = "SPONSOR_LOGO_STATS";
export const PARTNER_VALUE_PER_SOURCE = "PARTNER_VALUE_PER_SOURCE";
export const ENGAGEMENT_CHANNELS = "ENGAGEMENT_CHANNELS";
export const PARTNER_ENGAGEMENT = "PARTNER_ENGAGEMENT";
export const PARTNER_ENGAGEMENT_VALUE = "PARTNER_ENGAGEMENT_VALUE";
export const SPONSOR_DIVIDED_ENGAGEMENT = "SPONSOR_DIVIDED_ENGAGEMENT";
export const SPONSOR_DIVIDED_ENGAGEMENT_VALUE =
  "SPONSOR_DIVIDED_ENGAGEMENT_VALUE";
export const PARTNERS = "PARTNERS";
export const TENANTS = "TENANTS";
export const MERGED = "MERGED";
export const DATA_SOURCES = "DATA_SOURCES";
export const BOXED_METRIC = "BOXED_METRIC";
export const ATHLETE = "ATHLETE";
export const PERIOD = "PERIOD";
export const REACH = "REACH";
export const SOCIAL_MEDIA_POST_WIDGET = "SOCIAL_MEDIA_POST_WIDGET";
export const PERFORMANCE_INDEX = "PERFORMANCE_INDEX";
export const MEDIA_VALUE_PERIOD = "MEDIA_VALUE_PERIOD";
export const REACH_VALUE_PERIOD = "REACH_VALUE_PERIOD";
export const ENGAGEMENT_VALUE_PERIOD = "ENGAGEMENT_VALUE_PERIOD";
export const SPONSOR_BRAND_VALUE = "SPONSOR_BRAND_VALUE";
export const IMAGE_DETECTION_EXAMPLE = "IMAGE_DETECTION_EXAMPLE";
export const PERSON_SOCIAL_METRICS = "PERSON_SOCIAL_METRICS";
export const PERSON_SOCIAL_TIMELINE = "PERSON_SOCIAL_TIMELINE";
export const TENANT_PROFILE_DATA = "TENANT_PROFILE_DATA";
export const ALL_BRANDS = "ALL_BRANDS";
export const SPONSOR_OBJECTS = "SPONSOR_OBJECTS";
export const SPONSOR_TV_DIVDED = "SPONSOR_TV_DIVDED";
export const SPONSOR_VALUE_DIVIDED_YEAR = "SPONSOR_VALUE_DIVIDED_YEAR";
export const SPONSOR_CONTRACTS = "sponsor-contracts";
export const TENANT_BRANDS = "tenant-brands";
export const SPONSOR_ROI = "sponsor-roi";
export const SPONSOR_CONTRACT_CATEGORY_DIVDED =
  "sponsor-contract-category-divded";
export const SURVEY_QUESTIONS = "SURVEY_QUESTIONS";
export const SURVEY_SEGMENT_METRICS = "SURVEY_SEGMENT_METRICS";
export const SPONSOR_PERFORMANCE_TABLE = "SPONSOR_PERFORMANCE_TABLE";
export const SPONSOR_LOGO_PLACEMENT_ANALYSIS = "SPONSOR_LOGO_PLACEMENT_ANALYSIS";
export const POST_OVERVIEW = "POST_OVERVIEW";
export const POST_COMMENTS = "POST_COMMENTS";
export const PROJECTS = "PROJECTS";
export const PROJECT_VIEWS = "PROJECT_VIEWS";
export const PROJECT_ENGAGEMENT = "PROJECT_ENGAGEMENT";
export const PROJECT_VALUE_DIVIDED = "PROJECT_VALUE_DIVIDED";
export const GAINED_FOLLOWERS = "GAINED_FOLLOWERS";
export const TOTAL_FOLLOWERS = "TOTAL_FOLLOWERS";
export const BEST_POSTS = "BEST_POSTS";
export const PROJECT_OVERVIEW = "PROJECT_OVERVIEW_V2";
export const PARTNER_SUM_DIVIDED = "PARTNER_SUM_DIVIDED";
export const SOCIAL_ACCOUNTS = "SOCIAL_ACCOUNTS";
export const SPONSOR_VALUE_BREAKDOWN = "SPONSOR_VALUE_BREAKDOWN";
export const VALUE_BREAKDOWN_DETAILS = "VALUE_BREAKDOWN_DETAILS";
export const EARNED_MEDIA_BY_ACCOUNT = "EARNED_MEDIA_BY_ACCOUNT";
export const FACEBOOK_PAGE_SEARCH = "FACEBOOK_PAGE_SEARCH";
export const TRACKED_FACEBOOK_PAGES = "TRACKED_FACEBOOK_PAGES";
export const INSTAGRAM_SEARCH = "INSTAGRAM_SEARCH";
export const MEDIA_VALUE_SUMMARY = "MEDIA_VALUE_SUMMARY";
export const MEDIA_VALUE_TIMELINE = "MEDIA_VALUE_TIMELINE";
export const MEDIA_VALUE_BY_EVENT = "MEDIA_VALUE_BY_EVENT";
export const MEDIA_VALUE_EXPOSURES = "MEDIA_VALUE_EXPOSURES";
export const PA_SPONSOR_OBJECTS = "PA_SPONSOR_OBJECTS";
export const PA_SUMMARY = "PA_SUMMARY";
export const PA_TIMELINE = "PA_TIMELINE";
export const PA_BY_PLACEMENT = "PA_BY_PLACEMENT";
export const PA_BY_EVENT = "PA_BY_EVENT";
export const PA_BY_SPONSOR_OBJECT = "PA_BY_SPONSOR_OBJECT";
export const PA_VALUE_DRIVERS = "PA_VALUE_DRIVERS";
export const PA_EXPOSURE_DETAIL = "PA_EXPOSURE_DETAIL";
export const PA_BY_PLACEMENT_ATTRIBUTED = "PA_BY_PLACEMENT_ATTRIBUTED";
export const TRACKED_PAGE_DETECTIONS = "TRACKED_PAGE_DETECTIONS";

export const QUERY_KEYS = {
  SPONSOR_REACH,
  SPONSOR_VALUE,
  TV_ENGAGEMENT,
  BRAND_SOURCES,
  PARTNER_DIVIDED_REACH,
  PARTNER_VALUE,
  PARTNER_DIVIDED_VALUE,
  PARTNER_REACH,
  SPONSOR_DIVIDED_REACH,
  SPONSOR_DIVIDED_VALUE,
  SPONSOR_PERFORMANCE_BUBBLE,
  SPONSOR_STATION_DIVIDED_VALUE,
  SPONSOR_VALUE_PER_SOURCE,
  SPONSOR_LOGO_STATS,
  PARTNER_VALUE_PER_SOURCE,
  ENGAGEMENT_CHANNELS,
  PARTNER_ENGAGEMENT,
  PARTNER_ENGAGEMENT_VALUE,
  SPONSOR_DIVIDED_ENGAGEMENT,
  SPONSOR_DIVIDED_ENGAGEMENT_VALUE,
  PARTNERS,
  TENANTS,
  MERGED,
  DATA_SOURCES,
  BOXED_METRIC,
  ATHLETE,
  PERIOD,
  REACH,
  SOCIAL_MEDIA_POST_WIDGET,
  PERFORMANCE_INDEX,
  MEDIA_VALUE_PERIOD,
  REACH_VALUE_PERIOD,
  ENGAGEMENT_VALUE_PERIOD,
  SPONSOR_BRAND_VALUE,
  IMAGE_DETECTION_EXAMPLE,
  PERSON_SOCIAL_METRICS,
  PERSON_SOCIAL_TIMELINE,
  TENANT_PROFILE_DATA,
  ALL_BRANDS,
  SPONSOR_OBJECTS,
  SPONSOR_TV_DIVDED,
  SPONSOR_VALUE_DIVIDED_YEAR,
  SPONSOR_CONTRACTS,
  TENANT_BRANDS,
  SPONSOR_ROI,
  SPONSOR_CONTRACT_CATEGORY_DIVDED,
  SURVEY_QUESTIONS,
  SURVEY_SEGMENT_METRICS,
  SPONSOR_PERFORMANCE_TABLE,
  SPONSOR_LOGO_PLACEMENT_ANALYSIS,
  POST_OVERVIEW,
  POST_COMMENTS,
  PROJECTS,
  PROJECT_VIEWS,
  PROJECT_ENGAGEMENT,
  PROJECT_VALUE_DIVIDED,
  GAINED_FOLLOWERS,
  TOTAL_FOLLOWERS,
  BEST_POSTS,
  PROJECT_OVERVIEW,
  PARTNER_SUM_DIVIDED,
  SOCIAL_ACCOUNTS,
  SPONSOR_VALUE_BREAKDOWN,
  VALUE_BREAKDOWN_DETAILS,
  EARNED_MEDIA_BY_ACCOUNT,
  FACEBOOK_PAGE_SEARCH,
  TRACKED_FACEBOOK_PAGES,
  INSTAGRAM_SEARCH,
  MEDIA_VALUE_SUMMARY,
  MEDIA_VALUE_TIMELINE,
  MEDIA_VALUE_BY_EVENT,
  MEDIA_VALUE_EXPOSURES,
  PA_SPONSOR_OBJECTS,
  PA_SUMMARY,
  PA_TIMELINE,
  PA_BY_PLACEMENT,
  PA_BY_EVENT,
  PA_BY_SPONSOR_OBJECT,
  PA_VALUE_DRIVERS,
  PA_EXPOSURE_DETAIL,
  TRACKED_PAGE_DETECTIONS,
};